import RegisterOrganizationDialog from './registerOrganizationDialog';

export default RegisterOrganizationDialog;
